import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "./Profile.css";
import { get } from "../../util";
import NotFoundPage from "./NotFoundPage";
import { Grid } from "react-loader-spinner";

const Prof = ({ user }) => {
  const navigate = useNavigate();
  const { userId } = useParams();
  const [otherUser, setOtherUser] = React.useState<any>();
  useEffect(() => {
    if (!user) {
      return navigate("/");
    }
    get("/api/getUser", { userId }).then((u) => setOtherUser(u));
  }, [user, navigate]);

  if (otherUser === undefined)
    return (
      <div className="bg">
        <div className="center-screen">
          <Grid color="black" height={50} width={50} />
        </div>
      </div>
    );

  if (otherUser === null) {
    return <NotFoundPage />;
  }

  const gold_list = otherUser.goldDates.map((date) => (
    <h2>{new Date(date).toDateString()}</h2>
  ));
  const silver_list = otherUser.silverDates.map((date) => (
    <h2>{new Date(date).toDateString()}</h2>
  ));
  const bronze_list = otherUser.bronzeDates.map((date) => (
    <h2>{new Date(date).toDateString()}</h2>
  ));

  return (
    <>
      <div className="bg">
        <div className="u-textCenter">
          <img
            src={otherUser.picture.replace("s96-c", "s384-c")}
            className="Profile-picture"
          />
          <h1 className="name-header">{otherUser.name}</h1>
          <hr />
          <div className="u-inlineBlock">
            <h2 className="h2-text u-inlineBlock">
              All-Time Record: {otherUser.wins}-{otherUser.losses}
            </h2>
            <h2 className="h2-text u-inlineBlock">
              Season Total: {otherUser.totalScore} pts
            </h2>
          </div>
          <h2 className="h2-text">
            {user._id === otherUser._id
              ? "Your Medals:"
              : `${otherUser.name.split(" ")[0]}'s Medals:`}
          </h2>
          <div className="medalContainer">
            <div className="medalAndDate">
              <div className="goldMedal">x{otherUser.goldDates.length}</div>
              <div className="Dates-list">{gold_list}</div>
            </div>
            <div className="medalAndDate">
              <div className="silverMedal">x{otherUser.silverDates.length}</div>
              <div className="Dates-list">{silver_list}</div>
            </div>
            <div className="medalAndDate">
              <div className="bronzeMedal">x{otherUser.bronzeDates.length}</div>
              <div className="Dates-list">{bronze_list}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Prof;
